import { Icon, InlineStack, Tooltip } from '@customerio/pluma-components/react';
import { useProductTaxonomy } from '@/services/product-taxonomy';
import { SOURCES_TOOLTIP_CONTENT } from '../utils/sources';

/**
 * The three column headers that explain themselves on hover: what a
 * percentage is a percentage of, and how far back the source data goes.
 */

type ExplainedHeaderProps = {
  label: string;
  content: string;
};

function ExplainedHeader({ label, content }: ExplainedHeaderProps) {
  return (
    <Tooltip content={content} placement="top">
      <InlineStack alignBlock="center" gap="025">
        {label}
        <Icon name="info" size="sm" color="subtle" flexShrink="0" />
      </InlineStack>
    </Tooltip>
  );
}

type PeopleHeaderProps = {
  isEventBrowser: boolean;
};

export function PeopleHeader({ isEventBrowser }: PeopleHeaderProps) {
  const taxonomy = useProductTaxonomy();
  const plural = taxonomy.term('people.plural');

  return (
    <ExplainedHeader
      label={taxonomy.term('people.titlePlural')}
      content={
        isEventBrowser
          ? `Percentage of ${plural} that performed the event in the last 30 days`
          : `The percentage of ${plural} in your workspace that have this attribute`
      }
    />
  );
}

type ObjectHeaderProps = {
  objectTypeName: string;
};

export function ObjectHeader({ objectTypeName }: ObjectHeaderProps) {
  return (
    <ExplainedHeader
      label={objectTypeName}
      content={`The percentage of ${objectTypeName.toLowerCase()} in your workspace that have this attribute`}
    />
  );
}

export function SourcesHeader() {
  return <ExplainedHeader label="Sources" content={SOURCES_TOOLTIP_CONTENT} />;
}
